import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, useHistory, useParams } from 'react-router-dom';
import Router from '@alltrails/shared/components/ReactRouter';
import MinimalLayout from 'components/MinimalLayout';
import Signup from 'components/Signup';
import ReferralDownloadApp from '../ReferralDownload';
import ReferralWelcome from '../ReferralWelcome';
import CustomProvider from 'components/CustomProvider';

// we can leave this here or move it into a component directory 🤷‍♂️
function SignupRoute({ countryId, enableRecaptcha, facebookAppId }) {
  const history = useHistory();
  const { referralLink } = useParams();

  function handleRegistrationSuccess() {
    history.push('download'); // a little hidden
  }

  return (
    <Signup
      countryId={countryId}
      enableRecaptcha={enableRecaptcha}
      facebookAppId={facebookAppId}
      handleRegistrationSuccess={handleRegistrationSuccess}
      referralLink={referralLink}
    />
  );
}

function ReferralRouter({ countryId, enableRecaptcha, firstName, facebookAppId, fullpath }) {
  return (
    <CustomProvider>
      <MinimalLayout>
        <Router fullpath={fullpath}>
          <Switch>
            <Route path="/:locale?/invite/:referralLink" exact>
              <ReferralWelcome firstName={firstName} />
            </Route>
            <Route path="/:locale?/invite/:referralLink/signup" exact>
              <SignupRoute countryId={countryId} enableRecaptcha={enableRecaptcha} facebookAppId={facebookAppId} />
            </Route>
            <Route path="/:locale?/invite/:referralLink/download" exact>
              <ReferralDownloadApp />
            </Route>
          </Switch>
        </Router>
      </MinimalLayout>
    </CustomProvider>
  );
}

ReferralRouter.propTypes = {
  countryId: PropTypes.number.isRequired,
  enableRecaptcha: PropTypes.bool.isRequired,
  facebookAppId: PropTypes.number.isRequired,
  firstName: PropTypes.string.isRequired,
  fullpath: PropTypes.string.isRequired
};

export default ReferralRouter;
